<template>
<el-dialog title="企业认证信息" :visible.sync="visible" :show-close="false" width="400px">
  <el-form ref="authForm" :model="form" label-width="80px" :rules="rules">
    <el-form-item label="法人姓名" prop="legalPerson">
      <el-input v-model="form.legalPerson" autocomplete="off" style="width: 95%"></el-input>
    </el-form-item>
    <el-form-item label="身份证号" prop="legalPersonIdentity">
      <el-input v-model="form.legalPersonIdentity" autocomplete="off" style="width: 95%"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer" style="text-align: center">
    <el-button type="primary" @click="handleAuthConfirm" :loading="loading">认 证</el-button>
    <el-button @click="visible = false">取 消</el-button>
  </div>
</el-dialog>
</template>
<script>
const identityCardReg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
export default {
  name: 'AuthDialog',
  data() {
    const checkIdentityCard = (rule, value, callback) => {
       if (!value) {
          callback(new Error('请输入身份证号'));
        } else if (!identityCardReg.test(value)) {
          callback(new Error('身份证输入格式不对,请重新输入!'));
        } else {
          callback();
        }
    }
    return {
      visible: false,
      loading: false,
      form: {
        legalPerson: '',
        legalPersonIdentity: ''
      },
      rules: {
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        legalPersonIdentity: [
          { required: true, validator: checkIdentityCard, trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    show() {
      this.form = {
        legalPerson: '',
        legalPersonIdentity: ''
      }
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    handleAuthConfirm() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          this.companyRegister()
        } else {
          return false;
        }
      });
    },
    async companyRegister() {
      this.loading = true
      const res = await _api.contract.companyRegister(this.form)
      this.loading = false
      if (!res || !res.ret || !res.data) {
        if (res.error.code === 400005) {
          this.visible = false
        } else if (res.error.code === 400007) {
          this.visible = false
          this.$emit('success')
        }
        return
      }
      this.$emit('success')
      this.visible = false
    }
  }
}
</script>